export const currentStream = state => state.current;

export const streamsList = state => state.streams.data;

export const streamsListPage = state => state.streams.page;

export const streamsListFilter = state => state.streams.filter;

export const streamsListScope = state => state.streams.scope;

export const streamsListSearch = state => state.streams.search;

export const endOfList = state => state.streams.endOfList;

export const status = state => state.streams.status;
